import sanitizeHtml from 'sanitize-html';

/**
 * Sanitises an HTML string to only allow `<ins>` and `<del>` tags.
 * All other HTML tags and attributes are stripped to prevent XSS
 * from external API data.
 */
const sanitizeDiffHtml = (html: string): string => {
  if (!html) {return '';}

  return sanitizeHtml(html, {
    allowedTags: ['ins', 'del'],
    allowedAttributes: {},
  });
};

export { sanitizeDiffHtml };
